export const SET_ROUTE = 'SET_ROUTE'
export const SET_DISPLAY = 'SET_DISPLAY'


export const setRoute = (payload: any) => ({
    type: SET_ROUTE,
    payload
})

export const setDisplay = (payload: any) => ({
    type: SET_DISPLAY,
    payload
})